var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMoreButton = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more_horiz"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.8335 9.99992C3.8335 9.35939 4.35964 8.83325 5.00016 8.83325C5.64069 8.83325 6.16683 9.35939 6.16683 9.99992C6.16683 10.6404 5.64069 11.1666 5.00016 11.1666C4.35964 11.1666 3.8335 10.6404 3.8335 9.99992ZM13.8335 9.99992C13.8335 9.35939 14.3596 8.83325 15.0002 8.83325C15.6407 8.83325 16.1668 9.35939 16.1668 9.99992C16.1668 10.6404 15.6407 11.1666 15.0002 11.1666C14.3596 11.1666 13.8335 10.6404 13.8335 9.99992ZM8.8335 9.99992C8.8335 9.35939 9.35964 8.83325 10.0002 8.83325C10.6407 8.83325 11.1668 9.35939 11.1668 9.99992C11.1668 10.6404 10.6407 11.1666 10.0002 11.1666C9.35964 11.1666 8.8335 10.6404 8.8335 9.99992Z",
    fill: "#133155",
    stroke: "#133155"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoreButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/more_button.d886d6e9.svg";
export { ForwardRef as ReactComponent };